import { Autocomplete } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"

const AutocompletePessoa = ({ defaultValue = "", optionsDefault = [], condominio, disableByOtherComp = false, disabled = false, callback, imoveisSelecionado = false, index = false, reset = false, tipo = 'morador', newSx = {}, getOptionLabel = null }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [searchText, setSearchText] = useState('')

    const [pessoas, setPessoas] = useState(optionsDefault)

    const getPessoas = (msg) => {
        const pessoasBack = msg.data.moradores.map((morador) => {
            const nome = morador.NOME || morador.nome || ''
            const cd_acesso = morador.cd_acesso || ''
            const imovel = morador.imovel || ''
            const id_imovel_morador = morador.id_imovel_morador || morador.id_imovel || ''
            return { nome, cd_acesso, imovel, id_imovel_morador }
        })
        if (pessoasBack.length > 0) {
            setPessoas(pessoasBack)
        } else {
            setPessoas([])
        }
    }

    useEffect(() => {
        if (reset) {
            setSearchText('')
            setPessoas([])
            let result = { target: { type: 'outro', value: '', name: 'morador' } }
            callback(result)
        }
    }, [reset])

    useEffect(() => {
        if (imoveisSelecionado.length > 0) {
            if ((index == false || index == undefined) && index !== 0) {
                const id_imovel = imoveisSelecionado[0].id_imovel
                addRoute("getMoradorByImovel", getPessoas)
                sendWs("getMoradorByImovel", { id_central: condominio, id_imovel })
            } else {
                const imovelSelecionado = imoveisSelecionado.find((imovel) => imovel.index === index)
                if (imovelSelecionado) {
                    const id_imovel = imovelSelecionado.id_imovel
                    addRoute("getMoradorByImovel", getPessoas)
                    sendWs("getMoradorByImovel", { id_central: condominio, id_imovel })
                }
            }
        } else if (searchText.length > 2) {
            addRoute("buscarTodosMoradores", getPessoas)
            sendWs("buscarTodosMoradores", { text: searchText, id_central: condominio })
        } else if (defaultValue && defaultValue.length > 0) {
            addRoute("buscarTodosMoradores", getPessoas)
            sendWs("buscarTodosMoradores", { text: defaultValue, id_central: condominio })
        } else {
            setPessoas([])
            let result = {
                target: {
                    type: 'outro',
                    value: '',
                    name: 'morador'
                }
            }

            callback(result)
        }
    }, [searchText, imoveisSelecionado])

    const handleChangeInput = (event) => {
        setSearchText(event)
    }

    return (
        <Grid item xs={12}>
            <Autocomplete
                key={reset ? 'reset' : 'default'}
                options={pessoas}
                getOptionLabel={(option) => {
                    if (getOptionLabel) {
                        return getOptionLabel(option)
                    }

                    return option.nome || option
                }}
                filterOptions={(options) => options}
                noOptionsText={searchText.length > 2 ? "Nenhum morador encontrado" : "Digite pelo menos 3 números ou letras e aguarde"}
                defaultValue={defaultValue}
                disabled={disabled || disableByOtherComp}
                inputValue={searchText}
                isOptionEqualToValue={(option, value) =>
                    option.cd_acesso === value.cd_acesso && option.nome === value.nome
                }
                sx={{
                    '& input': {
                        border: 'none',
                        width: '100%',
                        bgcolor: (disabled || disableByOtherComp) ? '#c9c7c7' : 'background.paper',
                        color: (theme) =>
                            theme.palette.getContrastText(theme.palette.background.paper)
                    },
                    '& fieldset': {
                        border: 'none'
                    },
                    ...newSx
                }}
                onChange={(event, newValue) => {
                    let result = {
                        target: {
                            type: 'outro',
                            value: newValue?.nome || '',
                            name: 'morador',
                            index,
                            cd_acesso: newValue?.cd_acesso || '',
                            id_imovel_morador: newValue?.id_imovel_morador || ''
                        }
                    }
                    callback(result)
                }}
                onInputChange={(event, newInputValue) => {
                    handleChangeInput(newInputValue)
                }}
                renderInput={(params) => {
                    return (
                        <div data-index={`div-${index}`} style={{ width: '100%' }} ref={params.InputProps.ref}>
                            <input
                                placeholder={disabled ? "Selecione um condomínio" : "Digite pelo menos 3 letras e aguarde"}
                                style={{ width: '100%', height: '30px', borderRadius: '5px', ...newSx }}
                                {...params.inputProps}
                            />
                        </div>
                    )
                }}
            />
        </Grid>
    )
}

export default AutocompletePessoa
